import { faCheck, faMinus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { Checkbox } from "react-aria-components";

interface AccessibleCheckboxProps {
  label?: string;
  checked?: boolean;
  indeterminate?: boolean;
  onChange?: (checked: boolean) => void;
  children?: React.ReactNode;
  warning?: boolean;
  className?: string;
}

const AccessibleCheckbox = ({
  label,
  checked,
  indeterminate,
  onChange = () => {},
  children,
  warning,
  className,
}: AccessibleCheckboxProps) => {
  return (
    <Checkbox
      isSelected={checked}
      aria-checked={indeterminate ? "mixed" : checked}
      isIndeterminate={indeterminate}
      onChange={onChange}
      className={`focus:none tw-flex tw-cursor-pointer tw-items-center tw-gap-3 tw-py-[2px] tw-text-base ${className}`}
      aria-label={label ? label : "None"}
      excludeFromTabOrder={true}
    >
      {({ isSelected, isIndeterminate }) => {
        const isSelectedOrIndeterminate = isSelected || isIndeterminate;
        const isNormal = !warning;
        return (
          <>
            <button
              className={classNames(
                "tw-flex tw-h-[18px] tw-min-h-[18px] tw-w-[18px] tw-min-w-[18px] tw-max-w-[18px] tw-flex-shrink-0 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-[3px] tw-border-2 tw-border-solid tw-p-0 tw-transition-colors tw-duration-200 focus:tw-ring-2 focus:tw-ring-blue-dark focus:tw-ring-offset-2",
                {
                  // Not Checked and normal
                  "tw-border-text-secondary tw-bg-white focus:tw-border-blue-dark":
                    !isSelectedOrIndeterminate && isNormal,
                  // Checked and normal
                  "tw-border-blue-dark tw-bg-blue-dark": isSelectedOrIndeterminate && isNormal,
                  // Not Checked and warning
                  "tw-border-warning-dark tw-bg-white focus:tw-border-warning-dark":
                    !isSelectedOrIndeterminate && !isNormal,
                  // Checked and warning
                  "tw-border-warning-dark tw-bg-warning-dark": isSelectedOrIndeterminate && !isNormal,
                },
              )}
              aria-label={label ? label : "None"}
            >
              {isIndeterminate && <FontAwesomeIcon icon={faMinus} className='tw-text-white' />}
              {isSelected && !isIndeterminate && <FontAwesomeIcon icon={faCheck} className='tw-text-white' />}
            </button>
            {label && (
              <span
                className='tw-text-gray-700 tw-select-none tw-font-lato tw-text-base focus:tw-ring-blue-dark focus:tw-ring-offset-2 '
                aria-label={label}
                aria-hidden={true}
              >
                {label}
              </span>
            )}
            {children && <div className='tw-ml-2'>{children}</div>}
          </>
        );
      }}
    </Checkbox>
  );
};
export default AccessibleCheckbox;
